export default "__VITE_ASSET__OL_QOaiT__"